import classes from "./ForgotPasswordBody.module.scss";
import ClipLoader from "react-spinners/ClipLoader";
import {showToast} from "../../../../common/utils"
import React from "react";
import FirstStep from "./FirstStep/FirstStep";
import SecondStep from "./SecondStep/SecondStep";
import ThirdStep from "./ThirdStep/ThirdStep";
import {connect} from 'react-redux';
import * as actions from '../../../../store/actions';
import {useNavigate} from "react-router-dom";
import {ROUTES_PATHS} from "../../../../common/enums";
import {PRIMARY_COLOR, TENANT_CONFIG} from "../../../../common/constants";

const ForgotPasswordBody = (props) => {

  const [step, setStep] = React.useState(0);
  const [email, setEmail] = React.useState('');
  const [otp, setOtp] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [resending, setResending] = React.useState(false); 
  const tenantName = "CommercialPrime"
  const navigate = useNavigate();

  const onResendCode = async () => {
    if (email !== '') {
      setResending(true);
      const value = await props.onSendEmailForForgotPassword(email);
      setResending(false);
      if (value === 'ACCOUNT_NOT_REGISTERED') {
        showToast("You are Not Registered!");
      } else if (value) {
        showToast("Verification code resent successfully!");
      } else {
        showToast("Sorry, Try Again!");
      }
    } else {
      showToast('Email is missing');
    }
  };

  const onButtonClick = async () => {
    if (step === 0) {
      if (email !== '') {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
          const value = await props.onSendEmailForForgotPassword(email);
          if (value === 'ACCOUNT_NOT_REGISTERED') {
            showToast("You are Not Registered!", '#FF6B6B'); // Error color
          } else if (value) {
            showToast("Please Check your Email Inbox!", '#DBB659'); // Success color
            setStep(1);
          } else {
            showToast("Sorry, Try Again!", '#FF6B6B'); // Error color
          }
        } else {
          showToast("Please Enter Valid Email", '#FFC107'); // Warning color
        }
      } else {
        showToast('Please enter your Email', '#FFC107'); // Warning color
      }
    } else if (step === 1) {
      if (otp !== '') {
        if (/^[0-9a-zA-Z]*$/.test(otp)) {
          const object = {
            email,
            otp,
            tenantName,
          };
          const value = await props.onVerifyOTP(object);
          if (value) {
            showToast("Your Email is Verified", '#DBB659'); // Success color
            setStep(2);
          } else {
            showToast("Token is Invalid!", '#FF6B6B'); // Error color
          }
        } else {
          showToast("Access only Numbers and Letters", '#FFC107'); // Warning color
        }
      } else {
        showToast('OTP Cannot be Empty', '#FFC107'); // Warning color
      }
    } else {
      const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@#$%^&+=_\-!¡?¿;:'",.<>\{\}\[\]\\/\|~`(•√π÷×¶∆£¢€¥^°={}\*]).{8,}$/;

      if (password === '') {
        showToast('Please enter a password', '#FFC107'); // Warning color
      } else if (confirmPassword === '') {
        showToast("Confirm Password cannot be Empty", '#FFC107'); // Warning color
      } else if (!password.match(passwordRegex)) {
        showToast('Password should have at least 8 characters and include letters, numbers, and special characters', '#FFC107'); // Warning color
      } else if (password !== confirmPassword) {
        showToast('Passwords do not match!', '#FF6B6B'); // Error color
      } else {
        const object = {
          email,
          password,
          tenantName,
        };
        const value = props.onChangeForgotPassword(object);

        if (value) {
          showToast('Password Recovery Success')
          setTimeout(() => navigate(ROUTES_PATHS.PUBLIC.LOGIN), 1500);
        } else {
          showToast('Sorry, Please try again!', '#FF6B6B'); // Error color
        }
      }
    }
  };


  const setEmailToState = (email) => {
    setEmail(email);
  };

  const setOtpToState = (code) => {
    setOtp(code);
  };

  const setPasswordToState = (password) => {
    setPassword(password);
  }

  const setConfirmPasswordToState = (password) => {
    setConfirmPassword(password);
  }


// Define a switch case to render the appropriate component based on the current step
let component;
switch (step) {
  case 0:
    component = <FirstStep setEmail={setEmailToState} email={email}/>;
    break;
  case 1:
    component = <SecondStep setOtp={setOtpToState} email={email} onResendCode={onResendCode} resending={resending}/>;
    break;
  case 2:
    component = <ThirdStep
      password={password}
      setPassword={setPasswordToState}
      confirmPassword={confirmPassword}
      setConfirmPassword={setConfirmPasswordToState}
    />;
    break;
  default:
    component = <FirstStep setEmail={setEmailToState} email={email}/>;
  }

  return (
    <div className={classes.ForgotPasswordBodyContainer}>
      <div className={classes.ForgotPasswordBody}>

        {component}

        <div>
          <div className={classes.StepperContainer}>
            <div className={step === 0 ? classes.ActiveStep : classes.InactiveStep}></div>
            <div className={step === 1 ? classes.ActiveStep : classes.InactiveStep}></div>
            <div className={step === 2 ? classes.ActiveStep : classes.InactiveStep}></div>
          </div>

          {props.loading ? (
            <div className={classes.SpinnerContainer}>
                <ClipLoader color={PRIMARY_COLOR} loading={true} size={20}/>
            </div>
          ) : (
            <button
              className={classes.SendButton}
              onClick={onButtonClick}
            >
              {step === 0 ? 'Send' : step === 1 ? 'Verify' : 'Save'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    onSendEmailForForgotPassword: (email) =>
      dispatch(actions.sendEmailForForgotPassword(email)),
    onVerifyOTP: (object) =>
      dispatch(actions.verifyOTP(object)),
    onChangeForgotPassword: (object) =>
      dispatch(actions.changeForgotPassword(object)),
  };
};

export default connect(null, mapDispatchToProps)(ForgotPasswordBody);
